import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getRiskMitigationHistoryData = createAsyncThunk(
  'alix/risk-mitigation-history-data',
  async (payload, toolkit) => {
    return await AxiosClient('GET', `/v1/risk-management/mitigation/history?caseId=${payload.caseId}&clientId=${payload.clientId}`, {}, toolkit)
  },
)
